import React, {useCallback} from 'react';
import {classes, style} from './doppe-layout-search-action.st.css';
import {DoppeTemplateInstance} from '../../../../doppe-sdk';
import {DoppeHideableValue, doppeHideableValueCreateHidden} from '../../../../client-server-common';
import {DoppeViewerAction} from '../../../doppe-viewer-action/doppe-viewer-action';
import {
    doppeDtoActionExtendWithDefaultProps,
    DoppeDtoActionViewType
} from '../../../../client-server-common/types/doppe-dto-action';
import {
    BymoTemplateSpeedDialAutoComplete,
    BymoTemplateSpeedDialSearchAppearance
} from '../../../bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata';
import {
    doppeActionTypeSpeedDial
} from '../../../../doppe-action-types/doppe-action-type-speed-dial/doppe-action-type-speed-dial';
import {DoppeTemplateBasedActionView} from '../../../doppe-template-based-action-view/doppe-template-based-action-view';
import {
    DoppeActionViewInnerContentCloseButton
} from '../../../doppe-action-view-inner-content-close-button/doppe-action-view-inner-content-close-button';
import {DoppeHideableValueRenderer} from '../../../doppe-hideable-value-renderer/doppe-hideable-value-renderer';
import {DoppLayoutContentHeader} from '../dopp-layout-content-header/dopp-layout-content-header';

export const DoppeLayoutSearchSection = React.memo(function DoppePagesSearchAction(props: DoppePagesSearchAction.Props) {
    const {
        searchPlaceholder,
        showActionsInSearch,
        actionButtonTemplate,
        searchAppearance,
        callToActionText,
        searchHeaderClassName
    } = props;

    const searchSectionIsVisible = searchAppearance !== BymoTemplateSpeedDialSearchAppearance.Hidden;

    const actionViewRenderFunction = useCallback<DoppeViewerAction.ActionViewRenderFunction>(renderProps => {
        return (
            <DoppeTemplateBasedActionView
                {...renderProps.actionViewContextProps}
                actionViewTemplate={actionButtonTemplate}
                renderInlineContentCloseButton={renderProps => {
                    return (
                        <DoppeActionViewInnerContentCloseButton
                            onCloseButtonClick={renderProps.closingFunction}
                        />
                    )
                }}
            />
        )
    }, [actionButtonTemplate])


    return (
        searchSectionIsVisible ? (
            <>
                <DoppeHideableValueRenderer
                    hideableValue={callToActionText}
                    renderFunction={callToActionText => {

                        const normalizedCallToActionText = callToActionText.trim();

                        return normalizedCallToActionText !== '' ? (
                            <DoppLayoutContentHeader
                                className={style(classes.supportText, searchHeaderClassName)}
                                text={normalizedCallToActionText}
                            />
                        ) : null
                    }}
                />
                <div>
                    <DoppeViewerAction
                        action={doppeDtoActionExtendWithDefaultProps({
                            viewType: DoppeDtoActionViewType.InPage,
                            settings: {
                                autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputFocus,
                                showFullScreenAutoCompleteOnMobile: true,
                                searchPlaceholder: searchPlaceholder,
                                showActionsInSearch: showActionsInSearch,
                            },
                            actionTypeId: doppeActionTypeSpeedDial.id,
                            callToActionDescription: doppeHideableValueCreateHidden(''),
                            enabled: true,
                            id: 'SPEED_DIAL',
                            name: `Enter a Code`
                        })}
                        renderActionView={actionViewRenderFunction}
                        openedFromSearch={true}
                    />
                </div>
            </>
        ) : null
    )
});

export namespace DoppePagesSearchAction {

    export interface Props {
        searchPlaceholder: DoppeHideableValue<string>,
        showActionsInSearch: boolean,
        actionButtonTemplate: DoppeTemplateInstance;
        searchAppearance: BymoTemplateSpeedDialSearchAppearance;
        callToActionText: DoppeHideableValue<string>;
        searchHeaderClassName?: string;
    }
}